// extracted by mini-css-extract-plugin
module.exports = {"container":"emptyEmail_container__1dsUm","text":"emptyEmail_text__2YCBf"};